import React, { Component } from "react";
import "./DeconstructedLower.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class DeconstructedLower extends Component {
  constructor() {
    super();
    this.state = {
      visibleImages: 8
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    window.scrollTo({
      left: 0,
      top:
        document.querySelector(".DeconstructedImage-Wrapper").offsetTop - 100,
      behavior: "smooth"
    });
  }

  showVisibleImages(number) {
    const { data } = this.props;
    const newValue = number === "all" ? data.images.length : number;
    this.setState({
      visibleImages: newValue
    });
  }

  render() {
    const { visibleImages } = this.state;
    const { data, language } = this.props;
    const renderimages = data.images.slice(0, visibleImages).map((item, index) => {
    const style = {
      backgroundImage: `url(${item.image})`,
    };
    return (
      <div className="DeconstructedImage-image" key={index}>
        <div className="DeconstructedImage">
          <div
            className='DeconstructedImage-active'
            style={ style }
          />
        </div>
        <p className='DescDC'>{item.desc}</p>
        </div>
      );
    });
    return (
      <div className="DeconstructedProducts">
        <div className="Title">
          <h3>{data.title[language]}</h3>
        </div>
        <div className="ControlButtons">
          <button
            className="ControlButton"
            onClick={() => this.showVisibleImages(20)}
          >
            20
          </button>
          <p className="ControlDivider">|</p>
          <button
            className="ControlButton"
            onClick={() => this.showVisibleImages(40)}
          >
            40
          </button>
          <p className="ControlDivider">|</p>
          <button
            className="ControlButton"
            onClick={() => this.showVisibleImages("all")}
          >
            {data.description[language]}
          </button>
        </div>
        <div className="DeconstructedImage-Wrapper">{renderimages}</div>
        <div className="ControlButtons">
          <button
            className="ControlButton"
            onClick={() => this.showVisibleImages(20)}
          >
            20
          </button>
          <p className="ControlDivider">|</p>
          <button
            className="ControlButton"
            onClick={() => this.showVisibleImages(40)}
          >
            40
          </button>
          <p className="ControlDivider">|</p>
          <button
            className="ControlButton"
            onClick={() => this.showVisibleImages("all")}
          >
            {data.description[language]}
          </button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default withRouter(connect(mapStateToProps)(DeconstructedLower));



// WEBPACK FOOTER //
// ./src/components/Deconstructed/DeconstructedLower/index.js